export default "__VITE_ASSET__DVYFASSC__"